"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _Tooltip = _interopRequireWildcard(require("@mui/material/Tooltip"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _styles = require("@mui/material/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SNETTooltip = _ref => {
  let {
    tooltipText,
    placement
  } = _ref;
  const StyledTooltip = (0, _styles.styled)(_ref2 => {
    let {
      className,
      ...props
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({}, props, {
      classes: {
        popper: className
      }
    }));
  })(_ref3 => {
    let {
      theme
    } = _ref3;
    return {
      [`& .${_Tooltip.tooltipClasses.tooltip}`]: {
        fontSize: "16px",
        boxShadow: `0 8px 10px 1px rgba(0,0,0,0.14),
         0 3px 14px 2px rgba(0,0,0,0.12),
         0 5px 5px -3px rgba(0,0,0,0.2)`,
        background: theme.palette.text.lightGrey
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement(StyledTooltip, {
    children: /*#__PURE__*/_react.default.createElement(_IconButton.default, null, /*#__PURE__*/_react.default.createElement(_Info.default, null)),
    placement: placement || "top-end",
    title: /*#__PURE__*/_react.default.createElement("p", null, tooltipText)
  });
};
var _default = exports.default = SNETTooltip;